// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    setHotWaterStatusSuccess: {
        id: 'heating-hotwater.status-set-success',
        defaultMessage: 'You have advanced a time slot in your schedule. Next time slot at {nextStartTime}'
    }
});



// WEBPACK FOOTER //
// ./src/core/state/products/heating-hotwater/intl.js